export type Details = {
  badge: string;
  title: string;
  accentWord: string;
  subtitle: string;
};

export const DocumentsPageDetails: Details = {
  badge: 'Repositório Institucional',
  title: 'Documentos Oficiais.',
  accentWord: 'Oficiais.',
  subtitle:
    'Consulte atas, editais, regulamentos e outros documentos públicos da Junta de Freguesia.',
};
